export default "__VITE_ASSET__Bfq2KGwg__"